// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"b503dbcb","5286":"f7c830e4"}[chunkId] + ".chunk.css";
};